import { officeApi } from "./config";
// 게시물 공통 api

export const NetworkError = {
  state: false,
  data: undefined,
  msg: "네트워크 연결을 확인해주세요",
};

/** 게시물 불러오기 */
const GetPost = (
  bbs_id: number,
  page: number,
  filter?: string,
  text?: string
) => {
  return officeApi
    .get(
      `/web/cmnt/2?bbs_id=${bbs_id}&page=${page}&row_limit_cnt=20${
        filter ? filter : ""
      }${text ? `&ctts_tit=${text}` : ""}`
    )
    .then(({ data }) => {
      if (data.sts_fg) {
        return {
          state: true,
          data: data.succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          data: undefined,
          msg: data.err_msg,
        };
      }
    })
    .catch((error) => {
      return NetworkError;
    });
};

type DeleteType = {
  data: {
    bbs_id: number;
    ctts_tit: string;
    ctts_ctts: string;
  };
  ctts_id: string;
};

/** 게시물 삭제 */
const DeletePost = ({ data, ctts_id }: DeleteType) => {
  return officeApi
    .delete(`/web/cmnt/2/ctts/${ctts_id}`, {
      data,
    })
    .then((result) => {
      const { data } = result;
      if (data.sts_fg) {
        return {
          state: true,
          data: data.succ_obj,
          msg: "요청 성공",
        };
      } else {
        return {
          state: false,
          data: undefined,
          msg: data.err_msg,
        };
      }
    })
    .catch(() => {
      return NetworkError;
    });
};

/** 게시물 등록, 수정 */
const AddPost = (data: any) => {
  return officeApi
    .post(`/web/cmnt/2/ctts`, data)
    .then(({ data: { sts_fg, err_msg } }) => {
      return {
        state: sts_fg,
        msg: sts_fg ? "게시물 등록 완료" : err_msg,
      };
    })
    .catch((e) => {
      return NetworkError;
    });
};

/** 프로젝트 저장 */
const AddProject = (data: any) => {
  return officeApi
    .post("/cstm/prjt", data)
    .then(({ data: { sts_fg, err_msg } }) => {
      return {
        state: sts_fg,
        msg: sts_fg ? "프로젝트 등록 완료" : err_msg,
      };
    })
    .catch((err) => {
      return NetworkError;
    });
};
/** 프로젝트 임시저장 */
const SaveProject = (data: any) => {
  return officeApi
    .post("/cstm/prjt/tmp", data)
    .then(({ data: { sts_fg, err_msg } }) => {
      return {
        state: sts_fg,
        msg: sts_fg ? "프로젝트 임시저장 완료" : "임시저장 실패",
      };
    })
    .catch((err) => {
      return NetworkError;
    });
};

/** 프로젝트 재개 */
const ReStartProject = (id: string) => {
  return officeApi
    .put(`/cstm/prjt/${id}/rcrt/start`)
    .then(({ data: { sts_fg, err_msg } }) => {
      return {
        state: sts_fg,
        msg: sts_fg ? "프로젝트 재개" : err_msg,
      };
    })
    .catch(() => {
      return NetworkError;
    });
};

export {
  GetPost,
  DeletePost,
  AddPost,
  AddProject,
  ReStartProject,
  SaveProject,
};
